import React, { useEffect } from "react";
import Sidebar from "../../Sidebar/Sidebar";
import Header from "../Header/Header";
import "./diary.css";
const Diary = () => {
  let arrowUpIcon = (
    <svg
      width="24"
      height="12"
      viewBox="0 0 24 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute right-5 top-5"
    >
      <path d="M0 12L12 0L24 12H0Z" fill="black" />
    </svg>
  );
  
  const options = ["The Paractice"];
  const onOptionChangeHandler = (event) => {};
  return (
    <>
      <div className="grid grid-cols-12">
        {/* sidebar */}
        <div className="grid col-span-2">
          <Sidebar acitveRoute={"diary"} />
        </div>
        {/*write component */}
        <div className="col-span-10">
          <Header />
          <br />
          {/* heading + button */}
          <div className="flex justify-between p-4">
            <h1 className="text-2xl font-bold">Diary</h1>
            <button className="bg-[#4C004A] hover:bg-[#544354] text-white rounded-md py-2 px-4">
              Make Appointment
            </button>
          </div>
          <br />
          {/* titles: using grid system*/}
          {/* show this below div parent and inner is child we can show easily as big data*/}
          <div className="overflow-x-auto p-4">
            <div className="grid grid-cols-4 gap-5 bg-blue-200 p-3 relative w-[1290px]">
              {/* dropdown */}
              <select className="ml-20" onChange={onOptionChangeHandler}>
                {options.map((option, index) => {
                  return <option key={index}>{option}</option>;
                })}
              </select>
              {/* search box */}
              <div className="relative ml-20">
                <input
                  type="text"
                  placeholder="Search"
                  className="pl-8 pr-12 py-2 rounded-md border-gray-300 focus:outline-none focus:ring focus:border-blue-300 bg-[#F4F3F6]"
                />
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 27 27"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="absolute top-0 left-56 h-full flex items-center"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.3389 17.4129L26.6015 24.6758C26.8568 24.9312 27.0001 25.2776 27 25.6388C26.9999 25.9999 26.8563 26.3462 26.6008 26.6015C26.3454 26.8568 25.999 27.0001 25.6379 27C25.2767 26.9999 24.9304 26.8563 24.6752 26.6008L17.4125 19.338C15.2414 21.0196 12.5112 21.811 9.77742 21.5511C7.04359 21.2912 4.51146 19.9995 2.69613 17.9389C0.880803 15.8783 -0.0813541 13.2035 0.00539479 10.4586C0.0921436 7.71377 1.22128 5.10506 3.1631 3.16318C5.10493 1.22131 7.71357 0.0921459 10.4584 0.00539492C13.2031 -0.0813561 15.8779 0.880824 17.9384 2.6962C19.999 4.51157 21.2906 7.04377 21.5505 9.77766C21.8104 12.5116 21.0191 15.2418 19.3375 17.4129H19.3389ZM10.8005 18.8992C12.9487 18.8992 15.0088 18.0459 16.5278 16.5269C18.0468 15.0079 18.9001 12.9476 18.9001 10.7994C18.9001 8.65121 18.0468 6.59099 16.5278 5.07198C15.0088 3.55297 12.9487 2.6996 10.8005 2.6996C8.65235 2.6996 6.59218 3.55297 5.0732 5.07198C3.55423 6.59099 2.70088 8.65121 2.70088 10.7994C2.70088 12.9476 3.55423 15.0079 5.0732 16.5269C6.59218 18.0459 8.65235 18.8992 10.8005 18.8992V18.8992Z"
                    fill="#777777"
                  />
                </svg>
              </div>

              {/* date picker */}
              <div className="ml-44">
                <input
                  type="date"
                  className="pl-8 pr-12 py-2 rounded-md border-gray-300 focus:outline-none focus:ring focus:border-blue-300 bg-[#F4F3F6]"
                />
              </div>

              {/* arrow up icon */}
              {arrowUpIcon}
            </div>
            {/* Names */}
            <table width={"100%"} className="text-center bg-white w-[1290px]">
              <thead>
                <tr>
                  <th></th>
                  <th>
                    <h1 className="text-xl font-bold">Nick</h1>
                  </th>
                  <th>
                    <h1 className="text-xl font-bold">Olivia</h1>
                  </th>
                  <th>
                    <h1 className="text-xl font-bold">Sophia</h1>
                  </th>
                  <th>
                    <h1 className="text-xl font-bold">John</h1>
                  </th>
                </tr>
              </thead>
              <tbody>
                {/* row 1 */}
                <tr>
                  <td>
                    <span className="text-xl font-bold">9:00 am &nbsp;</span>
                  </td>
                  <td>
                    <div className="bg-green-600 rounded-md">
                      <div>9:00-9:30</div>
                      <div>Lorem ipsum</div>
                      <div>Contact Lens</div>
                    </div>
                  </td>
                  <td></td>
                  <td></td>
                  <td>
                    <div className="bg-red-600 text-white rounded-md">
                      <div>9:00-9:30</div>
                      <div>Lorem ipsum</div>
                      <div>Contact Lens</div>
                    </div>
                  </td>
                </tr>
                {/* row2 */}
                <tr>
                  <td>
                    <span className="text-xl font-bold">9:00 am &nbsp;</span>
                  </td>
                  <td></td>
                  <td>
                    <div className="bg-yellow-600 rounded-md">
                      <div>9:00-9:30</div>
                      <div>Lorem ipsum</div>
                      <div>Contact Lens</div>
                    </div>
                  </td>
                  <td>
                    <div className="bg-blue-600 text-white rounded-md">
                      <div>9:00-9:30</div>
                      <div>Lorem ipsum</div>
                      <div>Contact Lens</div>
                    </div>
                  </td>
                  <td></td>
                </tr>

                {/* row2 */}
                <tr>
                  <td>
                    <span className="text-xl font-bold">9:00 am &nbsp;</span>
                  </td>
                  <td></td>
                  <td>
                    <div className="bg-yellow-600 rounded-md">
                      <div>9:00-9:30</div>
                      <div>Lorem ipsum</div>
                      <div>Contact Lens</div>
                    </div>
                  </td>
                  <td>
                    <div className="bg-blue-600 text-white rounded-md">
                      <div>9:00-9:30</div>
                      <div>Lorem ipsum</div>
                      <div>Contact Lens</div>
                    </div>
                  </td>
                  <td></td>
                </tr>
                {/* row2 */}
                <tr>
                  <td>
                    <span className="text-xl font-bold">9:00 am &nbsp;</span>
                  </td>
                  <td></td>
                  <td>
                    <div className="bg-yellow-600 rounded-md">
                      <div>9:00-9:30</div>
                      <div>Lorem ipsum</div>
                      <div>Contact Lens</div>
                    </div>
                  </td>
                  <td>
                    <div className="bg-blue-600 text-white rounded-md">
                      <div>9:00-9:30</div>
                      <div>Lorem ipsum</div>
                      <div>Contact Lens</div>
                    </div>
                  </td>
                  <td></td>
                </tr>
                {/* row2 */}
                <tr>
                  <td>
                    <span className="text-xl font-bold">9:00 am &nbsp;</span>
                  </td>
                  <td></td>
                  <td>
                    <div className="bg-yellow-600 rounded-md">
                      <div>9:00-9:30</div>
                      <div>Lorem ipsum</div>
                      <div>Contact Lens</div>
                    </div>
                  </td>
                  <td>
                    <div className="bg-blue-600 text-white rounded-md">
                      <div>9:00-9:30</div>
                      <div>Lorem ipsum</div>
                      <div>Contact Lens</div>
                    </div>
                  </td>
                  <td></td>
                </tr>
                {/* row 1 */}
                <tr>
                  <td>
                    <span className="text-xl font-bold">9:00 am &nbsp;</span>
                  </td>
                  <td>
                    <div className="bg-green-600 rounded-md">
                      <div>9:00-9:30</div>
                      <div>Lorem ipsum</div>
                      <div>Contact Lens</div>
                    </div>
                  </td>
                  <td></td>
                  <td></td>
                  <td>
                    <div className="bg-red-600 text-white rounded-md">
                      <div>9:00-9:30</div>
                      <div>Lorem ipsum</div>
                      <div>Contact Lens</div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span className="text-xl font-bold">9:00 am &nbsp;</span>
                  </td>
                  <td></td>
                  <td>
                    <div className="bg-yellow-600 rounded-md">
                      <div>9:00-9:30</div>
                      <div>Lorem ipsum</div>
                      <div>Contact Lens</div>
                    </div>
                  </td>
                  <td>
                    <div className="bg-blue-600 text-white rounded-md">
                      <div>9:00-9:30</div>
                      <div>Lorem ipsum</div>
                      <div>Contact Lens</div>
                    </div>
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default Diary;
